import { IEntity } from "@messaia/cdk";
import { int } from "@zxing/library/esm/customTypings";
import { Attachment } from "./attachment";

export class Mail implements IEntity {
    id: int;
    clientId: number | null;
    customerId: number | null;
    recipient: string;
    cc: string;
    bcc: string;
    subject: string;
    content: string;
    attachments: Attachment[] = [];

    /**
     * constructor
     * @param init 
     */
    public constructor(init?: Partial<Mail>) {
        Object.assign(this, init);
    }
}